var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.482 27.368c7.461-.192 13.354-6.397 13.162-13.858C27.45 6.049 21.246.156 13.785.348S.431 6.745.624 14.206 7.02 27.56 14.482 27.368m4.621-11.745a3.579 3.579 0 1 0-.184-7.155 3.579 3.579 0 0 0 .184 7.155m-3.017 2.038a1.055 1.055 0 1 0-1.543-1.44 1.055 1.055 0 0 0 1.543 1.44m-2.356 2.557a1.055 1.055 0 1 0-1.696-1.256 1.055 1.055 0 0 0 1.696 1.256m-1.677-3.026a1.055 1.055 0 1 0-1.62-1.352 1.055 1.055 0 0 0 1.62 1.352m-1.805-2.98a1.055 1.055 0 1 0-1.443-1.54 1.055 1.055 0 0 0 1.443 1.54m-2.272-2.484a1.08 1.08 0 1 0-1.478-1.577 1.08 1.08 0 0 0 1.478 1.577",
  clipRule: "evenodd"
})));
export default SvgLogo;